// Default avatar image path - make sure to add default-avatar.png to public folder
export const DEFAULT_AVATAR = '/default-avatar.png';

// Helper to get avatar URL with fallback
export const getAvatarUrl = (profilePictureUrl: string | null | undefined): string => {
  if (!profilePictureUrl || profilePictureUrl.trim() === '') {
    return DEFAULT_AVATAR;
  }
  return profilePictureUrl;
};

